import React, { useMemo } from 'react'
import { navigate, useLocation, useParams } from '@reach/router'

import { Button } from '@refera/ui-web'

import { useBudgetForm } from '_/views/budget-view-v2/hooks/use-budget-form'

import { useToast } from '_/hooks/use-toast'
import useRolePermission from '_/hooks/use-role-permission'

import { ROUTES } from '_/utils/constants'
import { BUTTONS_ACTION } from '_/utils/constants/service-order'
import useCanDoButtonAction from '_/hooks/use-can-do-button-action'
import { parse } from 'query-string'

export default function NFSEButton() {
  const { pathname, search } = useLocation()
  const { budgetId, serviceOrderId } = useParams()

  const { isEditing } = useBudgetForm()
  const { isSAAS, isTradesman } = useRolePermission()

  const { showToast } = useToast()
  const { verification_token: token } = parse(search)

  const ableToSendNF = useCanDoButtonAction({
    nameButton: BUTTONS_ACTION.EDIT_BUDGET_BY_PROVIDER,
  })

  const dataNFURL = useMemo(
    () => `${ROUTES.NF_FORM}/${serviceOrderId}/orcamento/${budgetId}/?verification_token=${token}`,
    [budgetId, serviceOrderId, token]
  )

  function handleClick() {
    if ((isTradesman || isSAAS) && isEditing && ableToSendNF) {
      showToast({
        type: 'warning',
        message: 'Salve antes as edições deste registro.',
      })
      return
    }

    navigate(dataNFURL, { state: { from: `${pathname}${search}` } })
  }

  return (
    <Button onClick={handleClick} color="primary" variant="secondary">
      NFS-e
    </Button>
  )
}
